import { BarChart } from "@mui/x-charts/BarChart";

const chartSetting = {
  yAxis: [
    {
      label: "Fund Flow",
      width: 420,
    },
  ],
  height: 300,
};

export default function FundFlowNextChart({ dataset }) {
  const valueFormatter = (value) => {
    return `${value}`;
  };

  return (
    <div className="mx-6 mt-8">
      <BarChart
        dataset={dataset}
        xAxis={[
          {
            scaleType: "band",
            dataKey: "Period",
          },
        ]}
        series={[
          {
            dataKey: "OpeningBalance",
            label: "Opening Balance",
            valueFormatter,
            color: "#f56565",
          },
          {
            dataKey: "ProjectedBalance",
            label: "Projected Balance",
            valueFormatter,
            color: "#ecc94b",
          },
          {
            dataKey: "NetImpact",
            label: "Net Impact",
            valueFormatter,
            color: "#4299e1",
          },
          {
            dataKey: "ExpectedOutflow",
            label: "Expected Outflow",
            valueFormatter,
            color: "#7F00FF",
        },
        {
            dataKey: "ExpectedInflow",
            label: "Expected Inflow",
            valueFormatter,
            color: "#48bb78",
          },
        ]}
        {...chartSetting}
      />
    </div>
  );
}
